<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Project/POA/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>